// GET /invoices/me (#215, E7-S7): the customer's Billing History. Every type
// this contract needs lives in THIS file, so reconciling with the API half is a
// one-file change. Enums are ints, as the API serializes them.
import { SortDirectionType } from "./productFilter";

// Mirrors the API's InvoiceKindType (Domain/Types/InvoiceKindType.cs) —
// CONFIRMED against API main, member-for-member.
export enum InvoiceKindType {
    None = 0,
    Order = 1,
    Membership = 2,
}

// The `statuses` filter. PO ruling 2026-09-29: Issued and Voided only.
// CONFIRMED against the GET /invoices/me API half.
export enum InvoiceStatusType {
    None = 0,
    Issued = 1,
    Voided = 2,
}

// The `sortBy` values. IssuedAt is the API default. CONFIRMED, as above.
export enum GetMeInvoicesSortOptionType {
    None = 0,
    IssuedAt = 1,
    TotalAmount = 2,
    InvoiceNumber = 3,
}

// The house SortDirectionType, not a new declaration.
export { SortDirectionType };

export interface GetMeInvoicesQuery {
    // Repeated keys on the wire; omitted (empty) means all.
    kinds: InvoiceKindType[];
    statuses: InvoiceStatusType[];
    sortBy: GetMeInvoicesSortOptionType;
    sortDirection: SortDirectionType;
    pageNumber: number;
    pageSize: number;
}

// The order an order invoice belongs to. `status` is the OrderStatusType int;
// the UI does not render it (PO ruling 2026-09-29: no order status on invoices).
export interface MeInvoiceOrder {
    id: string;
    orderNumber: number;
    status: number;
}

// The billing period a membership invoice covers. `periodEnd` is EXCLUSIVE:
// a monthly period is 2026-03-01 .. 2026-04-01.
export interface MeInvoiceMembership {
    periodStart: string;
    periodEnd: string;
}

export interface MeInvoiceListItem {
    id: string;
    invoiceNumber: string;
    kind: InvoiceKindType;
    issuedAt: string;
    // Set when the invoice was voided; a voided invoice still downloads.
    voidedAt: string | null;
    totalAmount: number;
    // Exactly one of these is non-null, per `kind`.
    order: MeInvoiceOrder | null;
    membership: MeInvoiceMembership | null;
}

// The house PaginationList shape (as PaginatedOrders mirrors it).
export interface PaginatedMeInvoices {
    pageNumber: number;
    totalPages: number;
    count: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: MeInvoiceListItem[];
}
